// Seeded analysis, used to demonstrate the product before any upload.
//
// The findings are transcribed from reference/worked-premortem.md, a pre-mortem
// performed by hand against DOE/FEMP's own Example M&V Plan. They are not
// engine output — the engine does not exist yet — and the file says so.

import type { EvidenceCaseId } from '../evidence-cases';
import type { EngineLayer, FailureModeId, Tier } from '../../engine/types';
import type { QuoteOffsets } from '../../types';
import piscatawayAnalysis from './piscataway-analysis.json';

interface SeedFlag {
  id: string;
  failureModeId: FailureModeId;
  tier: Tier;
  layer: Extract<EngineLayer, 'deterministic' | 'model-assisted'>;
  title: string;
  /** Verbatim. Line breaks and leading whitespace are significant. */
  quote: string;
  sectionRef: string;
  /**
   * The page the clause is on, 1-based, matching the pages in
   * ./piscataway-pages.json. Generated rather than trusted: `npm run seed:check`
   * fails if it is not the page the quote is actually found on.
   */
  page: number;
  /**
   * Where the quote sits on that page, for the document pane's highlight.
   * Written by tools/seed-pages.ts from the shipped PDF — never by hand, since
   * an offset a person maintained would drift from the text it indexes into the
   * first time either changed.
   */
  quoteOffsets: QuoteOffsets | null;
  /** Which taxonomy detection_signal matched. */
  basis: string;
  evidenceCaseIds: EvidenceCaseId[];
  explanation: string;
}

export interface SeedAnalysis {
  documentId: string;
  documentTitle: string;
  facility: string;
  deliveryOrder: string;
  documentDate: string;
  preparedBy: string;
  documentUrl: string;
  documentNote: string;
  analysisSource: string;
  flags: SeedFlag[];
}

export const PISCATAWAY: SeedAnalysis = piscatawayAnalysis as SeedAnalysis;
